export default {
  strategies: [], // contém os detalhes do investimentos
  strategies_msg: "",
  investment: {},
  logs: [],
  orders: {},
  order_msg: "",
  logs_msg: "",
  limit_logs: false,
  date_range: {},
  loading: {
    logs: false,
    orders: false,
  },
};
